const getters = {
  permission_routers: state => state.permission.routers,
  // addRouters: state => state.permission.addRouters,

  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  // visitedViews: state => state.app.visitedViews,
  // cachedViews: state => state.app.cachedViews,

  id: state => state.user.id,
  token: state => state.user.token,
  role: state => state.user.role,
  menus: state => state.user.menus,
  powers: state => state.user.powers,
  name: state => state.user.name,
  addRouters: state => state.user.addRouters,
  // status: state => state.user.status,
  // setting: state => state.user.setting,
  roles: state => state.user.roles,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js